import React from "react";
import { Text } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";

function PrivacyPolicy() {
  const { pathname } = useLocation();
  const policyName = decodeURIComponent(pathname.substring(15)); // URL kodlamasını çöz

  return (
    <div className="container">
      <div className="header">
        <div className="header__right">
          <a href="/">
            <Text fontWeight="black" color="#fff" fontSize={20}>
              Muhammed Deniz
            </Text>
          </a>
        </div>

        <div className="header__left">
          <Link to="/home">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Home
            </Text>
          </Link>

          <Link to="/privacypolicy">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Privacy Policy
            </Text>
          </Link>
        </div>
      </div>

      <div style={{ margin: 60, marginLeft: "10%", marginRight: "15%" }}>
        <Text fontSize="xl" mb={5} fontWeight="black" color="#fff">
          Privacy Policy
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Your privacy is important to us. It is Muhammed Deniz's policy to
          respect your privacy regarding any information we may collect from you
          through our app,{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span>.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          We only ask for personal information when we truly need it to provide
          a service to you. We collect it by fair and lawful means, with your
          knowledge and consent. We also let you know why we’re collecting it
          and how it will be used.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          We only retain collected information for as long as necessary to
          provide you with your requested service. What data we store, we’ll
          protect within commercially acceptable means to prevent loss and
          theft, as well as unauthorised access, disclosure, copying, use or
          modification.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          We don’t share any personally identifying information publicly or with
          third-parties, except when required to by law.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Our app may link to external sites that are not operated by us. Please
          be aware that we have no control over the content and practices of
          these sites, and cannot accept responsibility or liability for their
          respective privacy policies.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Your continued use of our app will be regarded as acceptance of our
          practices around privacy and personal information. If you have any
          questions about how we handle user data and personal information, feel
          free to contact us.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          This policy is effective as of 4 may 2076.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          1. Terms
        </Text>

        <Text fontSize="m" color="#fff" mb={5}>
          By accessing our app,{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span>, you are
          agreeing to be bound by these terms of service, all applicable laws
          and regulations, and agree that you are responsible for compliance
          with any applicable local laws. If you do not agree with any of these
          terms, you are prohibited from using or accessing
          <span style={{ fontWeight: "bold" }}>{policyName}</span>. The
          materials contained in{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span> are protected
          by applicable copyright and trademark law.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          2. Use License
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Permission is granted to temporarily download one copy of{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span> per device
          for personal, non-commercial transitory viewing only. This is the
          grant of a license, not a transfer of title, and under this license
          you may not:
        </Text>

        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - modify or copy the materials;
        </Text>

        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - use the materials for any commercial purpose, or for any public
          display (commercial or non-commercial)
        </Text>
        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - attempt to decompile or reverse engineer any software contained in
          <span style={{ fontWeight: "bold" }}>{policyName}</span>
        </Text>
        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - remove any copyright or other proprietary notations from the
          materials; or
        </Text>
        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - transfer the materials to another person or &quot;mirror&quot; the
          materials on any other server.
        </Text>

        <Text fontSize="m" color="#fff" mt={10} mb={5}>
          This license shall automatically terminate if you violate any of these
          restrictions and may be terminated by Muhammed Deniz at any time. Upon
          terminating your viewing of these materials or upon the termination of
          this license, you must destroy any downloaded materials in your
          possession whether in electronic or printed format.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          3. Disclaimer
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          The materials within{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span>
          basis. Muhammed Deniz makes no warranties, expressed or implied, and
          hereby disclaims and negates all other warranties including, without
          limitation, implied warranties or conditions of merchantability,
          fitness for a particular purpose, or non- infringement of intellectual
          property or other violation of rights.
        </Text>
        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Further, Muhammed Deniz does not warrant or make any representations
          concerning the accuracy, likely results, or reliability of the use of
          the materials on its website or otherwise relating to such materials
          or on any sites linked to{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span>.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          4. Limitations
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          In no event shall Muhammed Deniz or its suppliers be liable for any
          damages (including, without limitation, damages for loss of data or
          profit, or due to business interruption) arising out of the use or
          inability to use{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span>, even if
          Muhammed Deniz or a Muhammed Deniz authorised representative has been
          notified orally or in writing of the possibility of such damage.
          Because some jurisdictions do not allow limitations on implied
          warranties, or limitations of liability for consequential or
          incidental damages, these limitations may not apply to you.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          5. Accuracy of materials
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          The materials appearing in{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span>
          could include technical, typographical, or photographic errors.
          Muhammed Deniz does not warrant that any of the materials on{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span> are accurate,
          complete or current. Muhammed Deniz may make changes to the materials
          contained in
          <span style={{ fontWeight: "bold" }}>{policyName}</span> at any time
          without notice. However Muhammed Deniz does not make any commitment to
          update the materials.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          6. Links
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Muhammed Deniz has not reviewed all of the sites linked to its app and
          is not responsible for the contents of any such linked site. The
          inclusion of any link does not imply endorsement by Muhammed Deniz of
          the site. Use of any such linked website is at the user own risk.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          7. Modifications
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Muhammed Deniz may revise these terms of service for its app at any
          time without notice. By using{" "}
          <span style={{ fontWeight: "bold" }}>{policyName}</span> you are
          agreeing to be bound by the then current version of these terms of
          service.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          8. Governing Law
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          These terms and conditions are governed by and construed in accordance
          with the laws of İstanbul and you irrevocably submit to the exclusive
          jurisdiction of the courts in that State or location.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          <div id="face-data-processing">9. Face Data Processing</div>
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Collection and Transit Processing
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Our app processes facial images that users voluntarily upload for AI
          headshot generation.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Our app processes facial images that users voluntarily upload for AI
          face rate.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • We do not store or retain any facial images on our servers.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Images are immediately and securely transmitted to our AI processing
          partner (Replicate) and are only held in temporary memory during
          transmission.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Once the image is processed and the result is delivered to you, no
          facial data is retained anywhere in our system.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Use of Face Data
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Facial images are used solely for generating AI-enhanced headshots
          through Replicate's AI service.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • The processing is temporary and occurs in real-time.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • We do not use face data for any other purposes such as
          identification, authentication, or marketing.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Third-Party Processing
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • We use Replicate's AI services to generate the headshots.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Images are transmitted securely to Replicate for processing.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • We do not sell, rent, or share your face data with any other third
          parties.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • For information about how Replicate handles data, please refer to
          their privacy policy.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Data Security
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • All data transmission is encrypted using industry-standard
          protocols.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • No facial data is stored or logged on our servers.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • The entire process is transient and occurs only during the active
          generation of your AI headshot or AI Face Rate.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          <div id="face-data-processing">9. Face Data Processing</div>
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          To comply with App Store review guidelines, we provide the following
          comprehensive information about face data processing:
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Face Data Collection
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Our app processes complete facial images that users voluntarily
          upload for AI face analysis.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • These facial images are consciously provided by users with their
          explicit consent for ChatGPT-based AI facial analysis.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • The face data we collect is limited to the original photograph
          uploaded by the user. We do not extract or store any biometric data
          (such as facial recognition data).
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Face Data Usage
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Facial images are used solely for providing the AI face analysis
          service requested by the user.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • The user's uploaded photo is transmitted to ChatGPT, where it is
          analyzed by OpenAI's image analysis model (such as GPT-4 Vision or
          similar).
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Face data is used exclusively for providing the service requested by
          the user and is not used for any other purposes (such as
          identification, authentication, marketing, or profiling).
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • The processing is temporary and occurs in real-time. Once the
          analysis is completed, the face data is removed from the processing
          pipeline.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Privacy Policy – Third-Party AI Processing
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          When you use the photo analysis feature, the images you capture or
          upload are sent to OpenAI (OpenAI, L.L.C.) for AI-based analysis and
          processing.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          The app does not store your photos or personal data on its servers.
          Images are transmitted securely and used only to generate analysis
          results.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          OpenAI processes this data in accordance with its Privacy Policy:{" "}
          <a
            href="https://openai.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline", color: "#fff" }}
          >
            https://openai.com/privacy
          </a>
          .
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Third-Party Sharing and Storage
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Face data is shared only with OpenAI (the provider of ChatGPT) for
          processing purposes.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Data is securely transmitted to OpenAI's API and is subject to
          OpenAI's privacy policy.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Users' face data is not stored or retained on our servers.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Data is temporarily processed by OpenAI in accordance with their
          privacy policies. For information about OpenAI's current privacy
          policies, please visit OpenAI's website.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • We do not sell, rent, or otherwise share your face data with other
          third parties except as described above.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Data Retention
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • We do not retain any facial images on our servers.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Face data is kept only for the duration necessary to complete the
          requested analysis.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Once the analysis results are delivered to you, no facial data is
          retained anywhere in our system.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • OpenAI may retain data according to their own privacy policy. Please
          refer to OpenAI's privacy policy for details on their data retention
          practices.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Data Security
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • All data transmission is encrypted using industry-standard
          protocols.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • We implement appropriate technical and organizational measures to
          protect your face data during transmission.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • The entire process is transient and occurs only during the active
          analysis of your facial image.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          User Control and Consent
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Face data processing occurs only when you voluntarily upload a photo
          and request analysis.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • You can choose not to upload facial images at any time.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • By uploading a facial image, you consent to its processing as
          described in this policy.
        </Text>

        <Text
          fontSize="xl"
          color="#fff"
          fontWeight="hairline"
          mt={20}
          mb={0}
          align="right"
        >
          Muhammed Deniz
        </Text>

        <Text
          fontSize="s"
          color="#fff"
          fontWeight="hairline"
          mt={0}
          mb={20}
          align="right"
        >
          <span style={{ fontWeight: "bold" }}>{policyName}</span>
        </Text>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
